/**
 * 티켓 상세의 절 이름. **사람이 쓴 글과 기계가 쓴 글을 가르는 유일한 표시다.**
 *
 * `TicketDetail` 안에 있던 것을 꺼냈다(2026-09-01) — 댓글 절(`Comments`)이
 * 같은 꼴을 써야 해서다. 상세의 큰 덩어리 셋(티켓 내용 · AI 요약 · 댓글)이
 * 같은 절 이름 꼴이어야 같은 층위로 읽힌다.
 *
 * **배지 꼴이다**(2026-08-30 지시). 이 화면의 다른 이름표(번호·유형·
 * 우선순위·배포 상태)가 전부 배지라, 절 이름만 맨 글자면 그것이 이름표인지
 * 본문의 첫 줄인지 헷갈린다.
 *
 * ⚠ **`h3` 를 유지한다.** 배지는 생김새고 문서 구조는 제목이다 — 화면
 * 낭독기가 이 자리를 건너뛰며 읽을 수 있어야 한다.
 */

import type { ReactNode } from 'react';

import { BADGE } from '../board/Chips';

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <h3 className="m-0 mb-s2">
      <span className={`${BADGE} bg-sunk font-bold text-ink-2`}>{children}</span>
    </h3>
  );
}
